// extracted by mini-css-extract-plugin
export default {"footerListItemLink":"footerListItem_footerListItemLink__r3-+K"};